import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const ratioTravelEntity: Entity = {
  model: model,
  repository: repository,
}

export default ratioTravelEntity
